import { ActionButtonFeatureConfigSchema, type ActionButtonFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `action-button` (the mobile "+" FAB).
 *
 * absentIsEmpty: the fleet-default GLOBAL_FEATURE_CONFIGS row has no
 * `action-button` block, and 14 of 33 school rows have none (read-only
 * production query, `SystemConfiguration`, 2026-10-02: action-button on 19 of 33).
 *
 * Fallback, for a school with no block:
 * - `enabled: false`: mobile hides the FAB when the block is absent
 *   (`apps/mobile/src/utils/fab-permissions.ts:335`).
 * - `visibleForRoles: ['faculty', 'admin']`: what the server's read fills into
 *   a stored block that lacks it (`apps/backend/src/services/config/global-feature-defaults.ts:44`,
 *   via `:88-90`), so a sparse `{ enabled: true }` save reads back as shown.
 */
export const actionButton: ScreenFeatureEntry<'global', 'action-button', ActionButtonFeatureConfig> = {
  resource: 'global',
  wireName: 'action-button',
  schema: ActionButtonFeatureConfigSchema,
  writeMode: 'sparse',
  absentIsEmpty: true,
  fallback: {
    enabled: false,
    visibleForRoles: ['faculty', 'admin']
  }
}
